module.exports = __webpack_public_path__ + "static/media/refilMedi.46927f07.svg";